import React from "react";
import styled from 'styled-components';
// import Button from 'src/components/Button';
import { useTranslation } from 'react-i18next';
import { Props } from 'react-modal';
import { Button, Popper } from "@mui/material";

interface MessageModalInterface extends Props {
  message: string;
  onClose: () => void;
}

const MessageModal: React.FC<MessageModalInterface> = ({ isOpen, message, onClose, ...props }) => {
  const [t] = useTranslation();

  return (
    <Popper open={isOpen}>
      <div css="font-size: 18px;text-align: center;">{message}</div>
      <div css="margin-top: 40px;">
        <Button css="margin-right: 25px;" onClick={onClose}>
          {t('BACK')}
        </Button>
      </div>
    </Popper>
  );
};

export default MessageModal;
